export default __webpack_public_path__ + "static/media/chef.54c81365.jpg";